import React, {memo} from 'react';
import './index.scss';
import {Image} from '../../components/Image';
import {onClickHandler} from '../../utils/onclick';

import {Configs} from '../../configs';

export const QRScreen = memo(function QRScreen({id, onClick}: { id: string; onClick: () => void; }) {
    return (
        <div className="qr-screen-wrapper" {...onClickHandler(onClick)}>
            <Image src={Configs.IMAGE_PREFIX + '/connection/' + id} interval={10000} alt=''/>
        </div>
    );
});
